import { DropDownOption } from "@data/types";
import { MantineSize } from "@mantine/core";
import Dropdown from "@ui/components/Dropdown/Dropdown";
import { FC, memo } from "react";

type Props = {
  label?: string;
  labelId?: string;
  placeholder?: string;
  options?: DropDownOption[];
  size?: MantineSize;
  required?: true;
  withAsterisk?: true;
  searchable?: boolean;
  disabled?: boolean;
  value?: string | null;
  onSelect?: (selectedValue: string | null) => void;
  onDropdownOpen?: () => void;
  errorMessage?: string;
  defaultValue?: string;
};

const UserFormDropDownMemo: FC<Props> = ({
  label = "",
  placeholder = "",
  options = [],
  size = "md",
  required,
  withAsterisk,
  searchable,
  disabled,
  value,
  onSelect,
  onDropdownOpen,
  errorMessage,
  defaultValue,
}) => {
  return (
    <>
      <Dropdown
        value={value}
        defaultValue={defaultValue}
        required={required}
        withAsterisk={withAsterisk}
        label={label}
        placeholder={placeholder}
        options={options}
        size={size}
        searchable={searchable}
        disabled={disabled}
        onSelect={onSelect}
        onDropdownOpen={onDropdownOpen}
        errorMessage={errorMessage}
      />
    </>
  );
};

export const UserFormDropDown = memo(UserFormDropDownMemo);
